// Custom elements for sections/brook-contact.liquid, so they also work after Customize
// re-renders the section.

// <brook-contact-form>: keeps the message across a failed send. Shopify hands back name, email
// and phone on its error page but has no property for the contact[note] field, so the message
// is saved in this tab's sessionStorage on submit, put back when the page returns with an
// error, and dropped otherwise.
if (!customElements.get('brook-contact-form')) {
  const storageKey = 'brook-contact-note';

  customElements.define(
    'brook-contact-form',
    class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.note = this.querySelector('[name="contact[note]"]');
        if (!this.form || !this.note) return;
        this.form.addEventListener('submit', this.onSubmit);

        const saved = this.read();
        if (saved && this.querySelector('.brook-contact__error') && !this.note.value) {
          this.note.value = saved;
        }
        this.write(null);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit);
      }

      onSubmit = () => this.write(this.note.value);

      // Storage can be unavailable (private windows, blocked site data); then nothing is kept.
      read() {
        try {
          return sessionStorage.getItem(storageKey);
        } catch {
          return null;
        }
      }

      write(value) {
        try {
          if (value) sessionStorage.setItem(storageKey, value);
          else sessionStorage.removeItem(storageKey);
        } catch {}
      }
    }
  );
}

// <brook-contact-thanks>: opens its <dialog> as soon as it's on the page. Shopify only renders
// it after a message was sent successfully, so it's the thank-you popup. Closes with its X
// button, Esc (native) or a click on the backdrop.
if (!customElements.get('brook-contact-thanks')) {
  customElements.define(
    'brook-contact-thanks',
    class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.closeButton = this.querySelector('.brook-contact__close');
        if (!this.dialog) return;
        this.closeButton?.addEventListener('click', this.close);
        this.dialog.addEventListener('click', this.onDialogClick);
        if (!this.dialog.open) this.dialog.showModal();
      }

      disconnectedCallback() {
        this.closeButton?.removeEventListener('click', this.close);
        this.dialog?.removeEventListener('click', this.onDialogClick);
      }

      close = () => this.dialog.close();

      // The dialog box fills the <dialog>, so a click on the <dialog> itself is on the backdrop.
      onDialogClick = (event) => {
        if (event.target === this.dialog) this.dialog.close();
      };
    }
  );
}
